<form [formGroup]="form">
    <label style="margin-top: 16px;" class="p-10"> 
        {{field.label}}

        <mat-slide-toggle 
        [formControlName]="field.fieldName"
        [checked]="field.value"
        class="custom-slide-toggle"
        [color]="color"
    >
        
    </mat-slide-toggle>

    </label>
    
</form>

